<template>
  <div class="edit-share">
    <!-- Contentタブ -->
    <div v-if="showTabContent">
      <share-content
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partId="parts[0].id"
        :parts="parts"
        :partsContainerType="partsContainerType"
        :attrs="parts[0].attrs"
        :shareText="partsContainer.share_text"
      />
    </div>
    <!-- Styleタブ -->
    <div v-if="showTabStyle">
      <!-- ボックスのスタイル -->
      <share-container-style
        :styles="containerStyles"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
      />
      <!-- テキストのスタイル -->
      <share-text-style
        :value="parts[0].styles"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partId="parts[0].id"
      />
    </div>
    <!-- 設定タブ -->
    <div v-if="showTabSetting">
      <!-- レイアウト -->
      <share-part-layout
        :displaySns="parts[0].attrs['data-display-sns']"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partId="parts[0].id"
        :align="partsContainerAlign"
        :layoutType="partsContainerLayoutType"
        :iconSize="parts[0].attrs['width']"
        :srcType="partsContainer.src_type"
        :firstSnsName="parts[0].attrs['data-sns-name']"
        :partsContainerType="partsContainerType"
      />
      <!-- パーツの背景色 -->
      <share-parts-container-style
        :styles="styles"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partsContainerType="partsContainerType"
      />
    </div>
  </div>
</template>

<script>
import SnsIconPartBase from '@/mixins/SnsIconPartBase'
import ShareContent from '@/components/Content/Palette/EditPartDesign/Editor/Share/ShareContent'
import ShareContainerStyle from '@/components/Content/Palette/EditPartDesign/Editor/Share/ShareContainerStyle'
import ShareTextStyle from '@/components/Content/Palette/EditPartDesign/Layouts/StyleTab/TextStyle'
import SharePartLayout from '@/components/Content/Palette/EditPartDesign/Layouts/SettingTab/SnsIconLayout'
import SharePartsContainerStyle from '@/components/Content/Palette/EditPartDesign/Layouts/PartsContainerStyle'

export default {
  props: [
    'current',
    'partsContainer',
    'parts',
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'styles',
  ],
  mixins: [
    SnsIconPartBase,
  ],
  components: {
    ShareContent,
    ShareContainerStyle,
    ShareTextStyle,
    SharePartLayout,
    SharePartsContainerStyle,
  },
  computed: {
    showTabContent () {
      return this.current.tab === 'Content'
    },
    showTabStyle () {
      return this.current.tab === 'Style'
    },
    showTabSetting () {
      return this.current.tab === 'Setting'
    },
  },
}
</script>

<style lang="scss">
.edit-share {
  .style-tab-text-style {
    .editor-design {
      .edit-style-select-color {
        // テキスト文字色のカラーピッカー
        .window {
          left: 0;
        }
      }
    }
  }
}
</style>
